import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            全部分类
          </h2>
          <Link
            to="/category/dianshiju"
            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors flex items-center gap-1 cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-2xl bg-background-100 
                hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl 
                bg-background-50 group-hover:bg-background-50/20 transition-colors">
                <i className={`${cat.icon} text-2xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-background-50 
                transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}